import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const consentItemStyle = StyleSheet.create({
    container: {
        paddingLeft: 8
    },
    title: {
        color: 'white',
        fontSize: 18,
        lineHeight: 28,
        width: '90%'
    },
    desc: {
        color: '#FFFFFF',
        fontSize: 18,
        paddingVertical: 20,
        fontFamily: Theme.thinFont
    },
    tabletWebDescPadding: {
        paddingRight: 120
    },
    phoneDescPadding: {
        paddingRight: 60
    },
    clickableRow: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    rightOffset: {
        paddingRight: 20
    },
    buttonText: {
        color: Theme.primaryLinkColor,
        fontSize: 12
    },
    blueButtonContainer: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    blueButtonIcon: { height: 8, justifyContent: 'center', width: 6 }
});

export default consentItemStyle;
